export default __webpack_public_path__ + "static/media/1745.a08d9af6.png";